<div class="page-container" [style.margin-left]="layoutContentMarginLeft" [class.chat-open]="isOpenSendbirdChat">
  <div class="main-container">
    <div class="container">
      <div class="content-box header">
        <!-- logo -->
        <div class="header-left">
          @if ((isH5 || isMobile) && fullMode) {
            <div class="menuButton" [routerLink]="" (click)="onMenuClick()">
              <i class="fi-menu-alt-2"></i>
            </div>
          }
          <app-logo
            [onlineSize]="['auto', '40']"
            [onlineSizeH5]="['auto', '36']"
            [sitSize]="['96', '40']"
            [sitSizeH5]="['75', '36']"
            [clickable]="true"
            [redefinedH5]="showH5Logo"
          ></app-logo>
        </div>

        <!-- 钱包 -->
        <app-currency-wallet *ngIf="logined && !simple"></app-currency-wallet>

        <!-- 顶部菜单 -->
        <div class="header-right">
          <app-h5-top-menu *ngIf="isH5; else webTopBar" [vipLoading]="vipLoading"></app-h5-top-menu>
          <ng-template #webTopBar>
            <app-top-bar [vipLoading]="vipLoading"></app-top-bar>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
